<template>
    <form class="form grid" :action="content.url" method="post">
        <div class="form--fieldset-row">
            <fieldset class="form--fieldset"
                    v-for="(fieldset, fieldsetIdx) in protectedFieldsets" :key="fieldsetIdx">
                <div class="grid--row form--legend-row">
                    <div class="grid--col form--legend"
                            v-if="fieldset.name">
                        <div class="form--fieldset-title">
                            <legend v-text="fieldset.name"></legend>
                        </div>
                    </div>
                    <div class="grid--col form--fields">
                        <div class="form--field-row">
                            <component :is="field.component"
                                    v-for="(field, fieldIdx) in fieldset.fields" key="field.id"
                                    class="form--field"
                                    :class="bemAdd(field.field_facet, 'field')"
                                    @recaptcha-submit="handleFormSubmit"
                                    v-model="field.val"
                                    v-bind="bindFieldData(field)">
                            </component>
                        </div>
                    </div>
                </div>
            </fieldset>
        </div>

        <!-- <pre v-if="content" v-text="content"></pre> -->
    </form>
</template>

<script>
    import formMixin from 'framework/mixins/form/form';


    const BASIC_FORM_FIELDS = [
        'cmp-form-field-bool',
        'cmp-form-field-input',
        'cmp-form-field-textarea',
        'cmp-form-field-select',
        'cmp-form-field-hidden',
    ];

    const FLOATING_LABEL_FORM_FIELDS = [
        'cmp-form-field-input',
        'cmp-form-field-textarea',
    ];

    const SUBMIT_FORM_FIELDS = [
        'cmp-form-submit',
    ];


    export default {
        mixins: [
            formMixin,
        ],
        methods: {
            bindFieldData(field) {
                const isBasicFormField = BASIC_FORM_FIELDS.includes(field.component);
                const isSubmitButton = SUBMIT_FORM_FIELDS.includes(field.component);
                const hasFloatingLabel = FLOATING_LABEL_FORM_FIELDS.includes(field.component);
                const { placeholder, type, label, items, id, state, messages, pattern } = field;
                let result = {};

                switch (true) {
                    case isBasicFormField:
                        result = { hasFloatingLabel, placeholder, type, label, items, id, state, messages, pattern };
                        break;
                    case isSubmitButton:
                        result = {
                            label,
                            isSubmitting: this.isSubmitting,
                            sitekey: field.recaptcha_sitekey,
                            generalErrors: this.generalErrors,
                        };
                        break;
                    default:
                        this.$log.warn(`Unable to handle field with type ${ field.component }!`);
                        break;
                }

                return result;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/base-form/index.vue?b05e2014